import * as React from "react";
import ReactTable from "react-table";
import { TrazaEstado} from "../../documentos/modelo/Documento";
import { FiltroHistoricos } from "../modelo/Historicos";

export default class TablaHistoricosIndependientes extends React.Component<TablaHistoricosIndependientesProps> {

    columns = [{
        Header: "EMPRESA CONTRATANTE",
        accessor: "dniEmpleador",
    },{
        Header: "INDEPENDIENTE",
        accessor: "dni",
    },{
        Header: "NOMBRE INDEPENDIENTE",
        accessor: "nombreAfiliado",
    }, {
        Header: "USUARIO OPERACIÓN",
        accessor: "dniAprueba",
    }, {
        Header: "OPERACIÓN",
        accessor: "estado"
    }, {
        Header: "FECHA DE CAMBIO",
        accessor: "fechaModificacion",
    }];

    render() {
        const {estados, paginas, tamanoPagina, paginaActual} = this.props;

        let numRegistros = 0;
        if (estados.length < tamanoPagina) {
            numRegistros = estados.length;
        } else {
            numRegistros = tamanoPagina;
        }

        return (
            <div className={"panel panel-success"}>
                <div className={"panel-heading"}>
                    <h2 className={"panel-title-white"}>
                        <span className="badge">{estados.length}</span> Documentos encontrados
                    </h2>
                </div>
                <ReactTable data={estados}
                            columns={this.columns}
                            manual
                            defaultPageSize={numRegistros}
                            pageSizeOptions={this.calcularOpciones(numRegistros)}
                            page={paginaActual}
                            sortable={false}
                            resizable={false}
                            previousText={"Anterior"}
                            nextText={"Siguiente"}
                            loadingText={"Cargando..."}
                            noDataText={"No se ha encontrado información."}
                            pageText={"Página"}
                            ofText={"de"}
                            rowsText={""}
                            className={"-highlight -striped"}
                            pages={paginas}
                            onPageChange={(pageIndex) => {
                                this.consultarCambioPagina(tamanoPagina, pageIndex, tamanoPagina);
                            }}
                            onPageSizeChange={(pageSize, pageIndex) => {
                                this.consultarCambioPagina(pageSize, pageIndex, tamanoPagina);
                            }}
                />
            </div>
        );
    }

    consultarCambioPagina(pageSize: number, pageIndex: number, tamanoPagina: number) {
        const filtroDocumento: FiltroHistoricos = {
            dni: this.props.filtroDocumento.dni,
            dniEmpleador: this.props.filtroDocumento.dniEmpleador,
            tipoCliente: "OI",
            fechaInicio: this.props.filtroDocumento.fechaInicio,
            fechaFin: this.props.filtroDocumento.fechaFin,
            registrosPorPagina: pageSize ? pageSize : tamanoPagina,
            pagina: pageIndex
        };
        this.props.consultaPaginada(filtroDocumento);
    }

    calcularOpciones(tamanoPagina : number) {
        const arreglo = [10, 20, 25, 50, 100];
        const elemento = arreglo.find(valor => valor === tamanoPagina);
        if( elemento ) {
            return arreglo;
        } else {
            return [...arreglo,tamanoPagina].sort( (a, b) => {return a-b;} );
        }
     }

}

interface TablaHistoricosIndependientesProps {
    estados: Array<TrazaEstado>,
    filtroDocumento: FiltroHistoricos,
    paginas: number,
    tamanoPagina: number,
    paginaActual: number,
    consultaPaginada?: (filtroDocumento: FiltroHistoricos) => void
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/reportes/componentes/TablaHistoricosIndependientes.tsx